'use client';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback, useEffect, useState } from 'react';

import { useFeatureFlagsReady } from 'src/hooks/useFeatureFlagsReady';
import { useExternalServiceStore } from 'src/stores/externalServiceStore';

import { RecaptchaAction, getRecaptchaToken as getRecaptchaTokenExecute } from './getRecaptchaToken';

export const useRecaptcha = () => {
  const flags = useFlags();
  const featureFlagsReady = useFeatureFlagsReady();
  const { recaptchaReady } = useExternalServiceStore();
  const [isLoadingRecaptcha, setIsLoadingRecaptcha] = useState<boolean>(true);
  const shoulUseRecaptcha = !!flags?.recaptcha;

  const getRecaptchaToken = useCallback(
    async (action: RecaptchaAction) => {
      if (isLoadingRecaptcha) {
        throw new Error('Please wait for recaptcha to load before invoking `getRecaptchaToken`');
      }
      if (shoulUseRecaptcha) {
        const recaptchaToken = await getRecaptchaTokenExecute(action);
        return recaptchaToken;
      }
      return '';
    },
    [isLoadingRecaptcha],
  );

  useEffect(() => {
    setIsLoadingRecaptcha(!featureFlagsReady || !recaptchaReady);
  }, [featureFlagsReady, recaptchaReady]);

  return {
    isLoadingRecaptcha,
    shoulUseRecaptcha,
    getRecaptchaToken,
  };
};
